<template>
    <v-dialog class="dialog" v-model="dialog" persistent max-width="400">
        <v-card>
            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('area')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon text @click="$emit('closeDialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-app-bar>
            <v-form v-model="valid">

                <v-card-title>
                    <v-text-field :rules="nameRules" v-model="area.name" :label="$t('name_area')" :placeholder="$t('name_area_placeholder')" outlined></v-text-field>
                </v-card-title>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" :disabled='!valid' @click="createArea">
                        {{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { SAVE_AREA, SET_MAPPAGE } from '../../../store/mutations'
import validators from '../../../utils/validators';
export default {
    name: 'DialogAreaName',
    data() {
        return {
            valid: false,
            nameRules: [
                v => validators.name.required(v) || this.$t('validators.name.required'),

            ],
        }
    },

    computed: {

        ...mapGetters({

            page: 'AreaVuex/mapPage',

            getProvider: `ProviderVuex/provider`,


        }),

    },

    props: ['dialog', 'area', 'createdPolygon'],

    methods: {

        ...mapActions({

            saveArea: `AreaVuex/${SAVE_AREA}`,

        }),

        ...mapMutations({ setPage: `AreaVuex/${SET_MAPPAGE}` }),

        async createArea() {

            const area = this.createdPolygon

            if (!area) return console.log('area nula')

            const areaToSave = this.area

            areaToSave.points = area;
            areaToSave.provider = this.getProvider._id;
            areaToSave.origin = 'map'

            this.showToast(this.$t('edit_areas.toast_save_msg'), this.$t('edit_areas.toast_save_title'), 'info')

            try {

                await this.saveArea(areaToSave);

                this.showToast(this.$t('edit_areas.toast_success_msg'), this.$t('edit_areas.toast_success_title'), 'success')

                await this.updatePage(1)

                this.$emit('cleanPolyData')

                this.$emit('closeDialog')

                return


            } catch (error) {

                this.showToast(this.$t('edit_areas.toast_error_msg'), this.$t('edit_areas.toast_error_title'), 'error')

            }

        },

        async updatePage(newPage) {

            await this.setPage(newPage)

        },

    },

}
</script>

<style>

</style>